import { Header, Text } from '@crossfit/design-system'
import { Link } from 'react-router-dom'
import style from './style.module.scss'
import { Role } from 'types'

export type HeroCTAProps = {
  cta: { headlineText: string; bodyText: string; link; icon; roleVisibility }
  affiliateRoles?: Role[] | string[]
}

export default function HeroCTA({ cta, affiliateRoles }: HeroCTAProps) {
  return (
    <Link key={cta.headlineText} to={cta.link.url}>
      <div className={style.heroCtas}>
        <div>
          <img
            src={cta.icon}
            alt={cta.headlineText}
            className={style.heroCtaIcon}
          />
        </div>
        <div className={style.ctaContent}>
          {cta.headlineText.includes('&') &&
            affiliateRoles?.includes(Role.LOR) && (
              <Header as='h4' size='xs' className={style.ctaHeadlineText}>
                {cta.headlineText}
              </Header>
            )}
          {cta.headlineText.includes('&') &&
            !affiliateRoles?.includes(Role.LOR) && (
              <Header as='h4' size='xs' className={style.ctaHeadlineText}>
                VIEW COACHES & STAFF
              </Header>
            )}
          {!cta.headlineText.includes('&') && (
            <Header as='h4' size='xs' className={style.ctaHeadlineText}>
              {cta.headlineText}
            </Header>
          )}

          <Text size='xs' className={style.ctaBodyText} type={'body'}>
            {cta.headlineText.includes('&') &&
            affiliateRoles?.includes(Role.Coach)
              ? 'View roles in the Affiliate Toolkit'
              : cta.bodyText}
          </Text>
        </div>
      </div>
    </Link>
  )
}
